





























import { Component, Vue, Watch, Prop } from "vue-property-decorator";

@Component({
  name: "landmarkEnterprise",
})
export default class extends Vue {
  // private goodsList:any = [];

  @Prop()
  inputPageEnterpriseData: any;

  @Watch("inputPageEnterpriseData", { immediate: true, deep: true })
  onInputPageEnterpriseData(val: any, oldVal: any) {
    // alert(11322)
    if (val) {
      // console.log('inputPageEnterpriseData--------axxxxxxxxx-',val)
    }
    // val.isOneLine = false;

    // this.inputPageEnterpriseData[1] = [val];

    // this.goodsList = val.pageEnterprise.enterpriseList;
    // console.log('inputPageEnterpriseData-------------',val);

    // this.pageHomeData = val;
    // this.designatedArticleListData =  val.designatedArticleList[0].article_list.article_list;
  }

  mounted() {
    console.log("mastermaster", this.inputPageEnterpriseData.slice(0, 5));

    // alert(12323)
    // alert(123)
    // setTimeout(()=>{
    //   var newarr:any = [this.inputPageEnterpriseData[0],this.inputPageEnterpriseData[1],this.inputPageEnterpriseData[3]];
    //   newarr.isOneLine = true;
    //   this.inputPageEnterpriseData = [this.inputPageEnterpriseData,newarr];
    // },1000)
  }

  private openUrl(item: any) {
    this.$router.push({
      name: "Article",
      query: {
        type: "2",
        landmarkId: item.landmark_id,
        id: item.id,
      },
    });
  }
}
